import { Checkbox, Icon, Tooltip } from "@mui/material";
import React, { useState } from "react";

export default function CustomizedCheckbox(props: {
    checked: boolean;
    disabled: boolean;
    onChange: (isChecked: boolean) => void;
}) {
    const [hover, setHover] = useState(false);

    const handleStatusChange = async (
        event: React.ChangeEvent<HTMLInputElement>
    ) => {
        props.onChange(event.target.checked);
    };

    return (
        <Tooltip
            title={props.checked ? "تغییر به انجام نشده" : "تغییر به انجام شده"}
            onMouseEnter={() => {
                setHover(true);
            }}
            onMouseLeave={() => {
                setHover(false);
            }}
        >
            <Checkbox
                onChange={handleStatusChange}
                checked={props.checked}
                disabled={props.disabled}
                icon={
                    hover ? (
                        <Icon>check</Icon>
                    ) : (
                        <Icon>check_box_outline_blank</Icon>
                    )
                }
                checkedIcon={<Icon>check_box</Icon>}
            />
        </Tooltip>
    );
}
